<div class="financeiro-page importar-extrato-banco">
  <div class="header d-flex justify-content-between align-items-start flex-wrap gap-2">
    <div>
      <h1>Importar Extrato Banco 1</h1>
      <p class="text-muted small mb-0">
        Importa a aba <strong>Banco 1</strong> da planilha Caixa:
        <strong>Créditos → Contas a Receber</strong>,
        <strong>Débitos → Contas a Pagar</strong>.
        Centros de custo e planos são pareados pelo nome/código já cadastrados.
      </p>
    </div>
    <a routerLink="/analise-centro-custos" class="btn btn-outline-secondary btn-sm">Análise Centro de Custos</a>
  </div>

  <div class="card-box mb-3">
    <h2 class="h6 mb-2">1. Arquivo</h2>
    <p class="small text-muted">
      Envie o <strong>.xlsx</strong> da planilha Caixa (aba Banco 1) com a senha, ou um <strong>.csv</strong> exportado.
      A API abre o Excel com senha via Microsoft Excel instalado neste servidor/máquina.
      Importação incremental: <strong>Data início</strong> padrão <strong>30/05/2026</strong>
      (após o último lançamento de 29/05/2026 em CR e CP).
    </p>
    <div class="row g-2 align-items-end">
      <div class="col-md-4">
        <label class="form-label small mb-1">Arquivo (xlsx / csv)</label>
        <input type="file" class="form-control form-control-sm" accept=".xlsx,.xls,.csv,.txt" (change)="onArquivoChange($event)" />
      </div>
      <div class="col-md-2">
        <label class="form-label small mb-1">Senha do Excel</label>
        <input type="password" class="form-control form-control-sm" [(ngModel)]="senha" placeholder="2325" autocomplete="off" />
      </div>
      <div class="col-md-2">
        <label class="form-label small mb-1">Aba</label>
        <input type="text" class="form-control form-control-sm" [(ngModel)]="nomeAba" />
      </div>
      <div class="col-md-2">
        <label class="form-label small mb-1">Data início (após 29/05/2026)</label>
        <input type="date" class="form-control form-control-sm" [(ngModel)]="dataInicio" />
      </div>
      <div class="col-md-2">
        <label class="form-label small mb-1">Data fim</label>
        <input type="date" class="form-control form-control-sm" [(ngModel)]="dataFim" />
      </div>
      <div class="col-md-3">
        <button type="button" class="btn btn-outline-primary btn-sm" [disabled]="processando || !arquivo" (click)="previewImportacao()">
          <i class="fa fa-search"></i> Pré-visualizar
        </button>
      </div>
    </div>
  </div>

  <div class="card-box mb-3 border-danger">
    <h2 class="h6 mb-2 text-danger">Limpar antes de reimportar</h2>
    <p class="small text-muted mb-2">
      Inativa Contas a Receber e Contas a Pagar (<code>STATUS = 0</code>).
      As telas de consultar só listam títulos com <code>STATUS = 1</code>.
      Hoje ainda existem títulos antigos (cadastro manual) ativos — marque
      <strong>Zerar tudo</strong> para limpar também eles antes de importar a planilha.
    </p>
    <div class="row g-2 align-items-end">
      <div class="col-md-5">
        <div class="form-check mb-2">
          <input class="form-check-input" type="checkbox" id="zerarTudo" [(ngModel)]="zerarTudo" />
          <label class="form-check-label" for="zerarTudo">
            Zerar <strong>tudo</strong> (recomendado): todos CR/CP ativos da empresa.
            Desmarque só se quiser apagar apenas a importação Banco 1.
          </label>
        </div>
      </div>
      <div class="col-md-3">
        <label class="form-label small mb-1">Digite ZERAR para confirmar</label>
        <input type="text" class="form-control form-control-sm" [(ngModel)]="confirmacaoZerar" autocomplete="off" placeholder="ZERAR" />
      </div>
      <div class="col-md-4">
        <button type="button" class="btn btn-danger btn-sm" [disabled]="processando" (click)="zerarContas()">
          <i class="fa fa-trash"></i> Zerar Contas a Pagar / Receber
        </button>
      </div>
    </div>
    <div class="alert alert-success py-2 small mt-2 mb-0" *ngIf="resultadoZerar">
      {{ resultadoZerar.mensagem }}
      (CR: {{ resultadoZerar.removidoscr || resultadoZerar.removidosCr }},
      CP: {{ resultadoZerar.removidoscp || resultadoZerar.removidosCp }};
      restantes ativos CR: {{ resultadoZerar.restantesativoscr || resultadoZerar.restantesAtivosCr }},
      CP: {{ resultadoZerar.restantesativoscp || resultadoZerar.restantesAtivosCp }})
    </div>
  </div>

  <div class="card-box mb-3">
    <h2 class="h6 mb-2">2. Destino no sistema</h2>
    <div class="row g-2">
      <div class="col-md-4">
        <label class="form-label small mb-1">Documento Contas a Receber</label>
        <select class="form-control form-control-sm" [(ngModel)]="idDocumentoCr">
          <option [ngValue]="0">Selecione...</option>
          <option *ngFor="let d of documentosCr" [ngValue]="d.id">{{ d.descricao }}</option>
        </select>
      </div>
      <div class="col-md-4">
        <label class="form-label small mb-1">Documento Contas a Pagar</label>
        <select class="form-control form-control-sm" [(ngModel)]="idDocumentoCp">
          <option [ngValue]="0">Selecione...</option>
          <option *ngFor="let d of documentosCp" [ngValue]="d.id">{{ d.descricao }}</option>
        </select>
      </div>
      <div class="col-md-4">
        <label class="form-label small mb-1">Fornecedor padrão (débitos)</label>
        <select class="form-control form-control-sm" [(ngModel)]="idFornecedorPadrao">
          <option [ngValue]="0">Selecione...</option>
          <option *ngFor="let f of fornecedores" [ngValue]="f.id">{{ f.descricao }}</option>
        </select>
      </div>
      <div class="col-md-4">
        <label class="form-label small mb-1">Usuário pagador (créditos / CR)</label>
        <select class="form-control form-control-sm" [(ngModel)]="idUsuarioPagador">
          <option [ngValue]="0">Selecione...</option>
          <option *ngFor="let u of usuarios" [ngValue]="u.id">{{ u.descricao }}</option>
        </select>
      </div>
      <div class="col-md-3">
        <label class="form-label small mb-1">Lote (opcional)</label>
        <input type="text" class="form-control form-control-sm" [(ngModel)]="lote" placeholder="ex: MAIO-2026" />
      </div>
      <div class="col-md-3 d-flex align-items-end">
        <div class="form-check mb-2">
          <input class="form-check-input" type="checkbox" id="marcarPago" [(ngModel)]="marcarPago" />
          <label class="form-check-label" for="marcarPago">Marcar como pago/recebido</label>
        </div>
      </div>
      <div class="col-md-3 d-flex align-items-end">
        <button type="button" class="btn btn-primary btn-sm" [disabled]="processando || !arquivo" (click)="confirmarImportacao()">
          <i class="fa fa-upload"></i> Confirmar importação
        </button>
      </div>
      <div class="col-md-3 d-flex align-items-end">
        <button type="button" class="btn btn-outline-secondary btn-sm" (click)="carregarComparativo()">
          Comparar totais importados
        </button>
      </div>
    </div>
  </div>

  <div class="card-box mb-3">
    <h2 class="h6 mb-2">Saldo inicial (Fluxo de Caixa)</h2>
    <p class="small text-muted mb-2">
      Informa o saldo de caixa em <strong>{{ dataSaldoInicialLabel }}</strong>.
      O sistema cria um título pago (positivo → Contas a Receber, negativo → Contas a Pagar)
      que o Fluxo de Caixa de <strong>{{ anoReferenciaSaldo }}</strong> usa como saldo anterior de janeiro.
      Pode lançar sozinho ou junto com a importação do arquivo.
    </p>
    <div class="row g-2 align-items-end">
      <div class="col-md-3">
        <label class="form-label small mb-1">Saldo inicial (R$)</label>
        <input type="number" step="0.01" class="form-control form-control-sm" [(ngModel)]="saldoInicial" placeholder="ex: 15000.00" />
      </div>
      <div class="col-md-2">
        <label class="form-label small mb-1">Ano do Fluxo</label>
        <input type="number" class="form-control form-control-sm" [(ngModel)]="anoReferenciaSaldo" min="2000" max="2100" />
      </div>
      <div class="col-md-5">
        <label class="form-label small mb-1">Plano de contas</label>
        <select class="form-control form-control-sm" [(ngModel)]="idPlanoSaldoInicial">
          <option [ngValue]="0">Selecione...</option>
          <option *ngFor="let p of planos" [ngValue]="p.id">{{ p.descricao }}</option>
        </select>
      </div>
      <div class="col-md-2">
        <button type="button" class="btn btn-success btn-sm w-100" [disabled]="processando" (click)="lancarSaldoInicial()">
          <i class="fa fa-balance-scale"></i> Lançar saldo
        </button>
      </div>
    </div>
  </div>

  <div class="card-box mb-3" *ngIf="preview">
    <h2 class="h6 mb-2">3. Pré-visualização</h2>
    <div class="resumo-grid mb-3">
      <div><span>Linhas</span><strong>{{ preview.totallinhas }}</strong></div>
      <div><span>Créditos ({{ preview.qtdcreditos }})</span><strong>{{ formatMoney(preview.totalcreditos) }}</strong></div>
      <div><span>Débitos ({{ preview.qtddebitos }})</span><strong>{{ formatMoney(preview.totaldebitos) }}</strong></div>
    </div>

    <div class="alert alert-warning py-2 small" *ngIf="preview.centrossemmatch?.length">
      Centros sem cadastro no sistema:
      <strong>{{ preview.centrossemmatch.join(', ') }}</strong>
    </div>
    <div class="alert alert-warning py-2 small" *ngIf="preview.planossemmatch?.length">
      Planos sem match (código/nome):
      <strong>{{ preview.planossemmatch.join(' · ') }}</strong>
      — o lançamento ainda é importado; o plano fica só na observação / sem composição.
    </div>

    <div class="table-responsive">
      <table class="table table-sm table-bordered preview-table">
        <thead>
          <tr>
            <th>Linha</th>
            <th>Data</th>
            <th>Tipo</th>
            <th>Valor</th>
            <th>Centro</th>
            <th>CC OK</th>
            <th>Plano</th>
            <th>Plano OK</th>
            <th>Info</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let item of preview.amostra">
            <td>{{ item.linhaarquivo }}</td>
            <td>{{ item.data }}</td>
            <td>
              <span [class.text-success]="item.tipo === 'CREDITO'" [class.text-danger]="item.tipo === 'DEBITO'">
                {{ item.tipo }}
              </span>
            </td>
            <td class="text-end">{{ formatMoney(item.valor) }}</td>
            <td>{{ item.centrocusto }}</td>
            <td class="text-center">{{ item.centrook ? '✓' : '✗' }}</td>
            <td>{{ item.codplanocontas }} {{ item.descricaoplanocontas }}</td>
            <td class="text-center">{{ item.planook ? '✓' : '✗' }}</td>
            <td>{{ item.informacoesadicionais }}</td>
          </tr>
        </tbody>
      </table>
    </div>
    <p class="small text-muted mb-0" *ngIf="preview.totallinhas > (preview.amostra?.length || 0)">
      Exibindo amostra das primeiras {{ preview.amostra?.length || 0 }} linhas de {{ preview.totallinhas }}.
    </p>
  </div>

  <div class="card-box mb-3" *ngIf="resultado">
    <h2 class="h6 mb-2">Resultado</h2>
    <p class="mb-1">{{ resultado.mensagem }}</p>
    <ul class="small mb-0">
      <li>CR criados: {{ resultado.criadoscr }}</li>
      <li>CP criados: {{ resultado.criadoscp }}</li>
      <li *ngIf="resultado.criadosaldoinicial != null">Saldo inicial: {{ resultado.criadosaldoinicial }}</li>
      <li>Ignorados (duplicados): {{ resultado.ignorados }}</li>
      <li>Erros: {{ resultado.erros }}</li>
      <li>Tag nas observações: <code>{{ resultado.tag }}</code></li>
    </ul>
  </div>

  <div class="card-box" *ngIf="comparativo">
    <h2 class="h6 mb-2">Totais já importados no sistema</h2>
    <p class="small text-muted">Período {{ comparativo.periodo?.inicio }} — {{ comparativo.periodo?.fim }} (somente lançamentos com tag {{ comparativo.tag }})</p>
    <div class="resumo-grid">
      <div><span>CR ({{ comparativo.qtdcreditos }})</span><strong>{{ formatMoney(comparativo.totalcreditos) }}</strong></div>
      <div><span>CP ({{ comparativo.qtddebitos }})</span><strong>{{ formatMoney(comparativo.totaldebitos) }}</strong></div>
    </div>
    <p class="small text-muted mb-0 mt-2">
      Na planilha Banco 1 (arquivo de maio): créditos R$ 519.259,36 · débitos R$ 903.938,64 — use o filtro de datas para bater o mesmo período.
    </p>
  </div>
</div>
